function getRawOrScaleValue(value, scale = null) {
    // check if value and scale are both numbers
    if ([value, scale].some(num => isNaN(num) || typeof num !== 'number')) {
        // if either value or scale are NaN, return the raw value
        return value;
    } else {
        // if value and scale are numbers, return value * scale
        return value * scale;
    }
}

/**
 * Handle get event value from streaming data.
 * @param {Object} event - event object
 * @param {object} key - key in event object (event[key] may be string, number, or an object)
 * @param {object} inner_key - key in event[key] object, if event[key] is an object
 * @param {object} scale - scaling factor for event value if event value is a number
 * @param {object} defaultValue - default value if key is not found in the event object.
 * @returns {(number|string)} - the value of the supplied key or default value if key now found.
 */
export default function getEventValue({
    event,
    key,
    inner_key = null,
    scale = null,
    defaultValue = '-'
}) {
    if (typeof event === 'object' && typeof key === 'string' && key in event) {
        if (event[key] !== null) {
            if (typeof inner_key === 'string' && inner_key in event[key]) {
                return getRawOrScaleValue(event[key][inner_key], scale);
            }
            return getRawOrScaleValue(event[key], scale);
        }
    }
    return defaultValue;
}
